import { Signal } from "signals";
import Layers from "slotworks/graphics/layers/layers";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";

export default class GambleComponent {
    public static readonly DEFAULT: string = "default";
    public static readonly GAMBLE: string = "gamble";

    public onGambleStart: Signal = new Signal();
    public onGambleCollect: Signal = new Signal();

    private SmartUIGroups: HeadlessSmartUIGroup[] = [];

    constructor() {
        if (Layers.GambleControls.hasScene(GambleComponent.DEFAULT)) {
            const group = SmartUIManager.newSmartUIGroup(Layers.GambleControls, GambleComponent.DEFAULT, "gamble");
            group.addEnableCondition([SmartUIFlag.GAMBLE]);
            group.addDisableCondition([SmartUIFlag.PROMPT]);
            group.addDisableCondition([SmartUIFlag.AUTO_SPIN]);
            group.addDisableCondition([SmartUIFlag.AWAITING_RESPONSE]);
            group.addDisableCondition([SmartUIFlag.GAMBLE_UI]);
            group.addDisableCondition([SmartUIFlag.MENU]);
            group.addDisableCondition([SmartUIFlag.EXTERNAL_DISABLE]);

            this.SmartUIGroups.push(group);
        }

        if (Layers.GambleControls.hasScene(GambleComponent.GAMBLE)) {
            const group = SmartUIManager.newSmartUIGroup(Layers.GambleControls, GambleComponent.GAMBLE, "gamble_ui");
            group.addEnableCondition([SmartUIFlag.GAMBLE_UI]);
            group.addDisableCondition([SmartUIFlag.PROMPT]);
            group.addDisableCondition([SmartUIFlag.AUTO_SPIN]);
            group.addDisableCondition([SmartUIFlag.AWAITING_RESPONSE]);
            group.addDisableCondition([SmartUIFlag.MENU]);
            group.addDisableCondition([SmartUIFlag.EXTERNAL_DISABLE]);

            this.SmartUIGroups.push(group);
        }
    }

    public start(): void {
        this.onGambleStart.dispatch();
    }

    public collect(): void {
        this.onGambleCollect.dispatch();
    }
}
